import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'

export const quantityPerRollColumn: ShipmentColumn = {
    key: 'quantityPerRoll',
    dataIndex: 'quantityPerRoll',
    title: 'Намотка',
    width: 70,
    render: formatIntegerBySpace,
    onCell: onCellStandard,
}
